import { createStateChainAccountContext } from '@/shared/hooks/useStateChainAccount';

export const {
  useStateChainAccount,
  useExtrinsicSDK,
  StateChainAccountProvider,
  useExtrinsicMutation,
} = createStateChainAccountContext({
  parseAccountInfo(account) {
    return account;
  },
  polkadotAppName: 'Chainflip Staking App',
  onboardedRole: 'operator',
});
